import script from "./CreateUpdateUser.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateUser.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateUser.vue?vue&type=style&index=0&id=0befb9ea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0befb9ea"]])

export default __exports__